export default __webpack_public_path__ + "static/media/028-meadow.578db2ef.svg";